export default $api => {
  $api.register('rollover-otp-api', '/web/private/client', request => ({
    verifyRolloverSms(payload) {
      return request('POST', '/rollover/verify', payload);
    },
    sendRolloverSms(payload) {
      return request('POST', '/rollover/sms-code', payload);
    },
  }));
};
